var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.client_mark)?_c('i',{class:[_vm.type_class]},[_c('fc-icon',{attrs:{"type":"32_pencil_white"}}),_vm._v(" "+_vm._s(_vm.client_mark)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }